import { render, staticRenderFns } from "./ModalVariant.vue?vue&type=template&id=22162116"
import script from "./ModalVariant.vue?vue&type=script&lang=js"
export * from "./ModalVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports